import { authenticate, unAuthenticate, loggedIn } from './auth.types';

export const authenticateUser = (userId, afterLogin) => ({
  type: authenticate,
  userId,
  afterLogin
});
export const unAuthenticateUser = () => ({ type: unAuthenticate });
export const userLoggedIn = () => ({ type: loggedIn });
